// extracted by mini-css-extract-plugin
module.exports = {"attachments":"NonUploadedFiles_attachments__3-0r2","filename":"NonUploadedFiles_filename__3MM7_","delete-file-icon":"NonUploadedFiles_delete-file-icon__3eq_J"};